import React from 'react';
import Icon from '../../../components/AppIcon';

const AIVisionIntegration = () => {
  const detectionStats = [
    { label: 'Automated Detections', value: '1,247', icon: 'Eye', color: 'text-blue-500' },
    { label: 'False Positives', value: '23', icon: 'XCircle', color: 'text-red-500' },
    { label: 'Detection Accuracy', value: '98.2%', icon: 'Target', color: 'text-green-500' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-foreground mb-2">AI Vision System Integration</h3>
        <p className="text-sm text-muted-foreground">
          Real-time safety monitoring with automated violation detection
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        {detectionStats?.map((stat, index) => (
          <div key={index} className="bg-muted/30 rounded-lg p-4">
            <div className="flex items-center gap-3 mb-2">
              <Icon name={stat?.icon} size={20} className={stat?.color} />
              <span className="text-sm text-muted-foreground">{stat?.label}</span>
            </div>
            <p className="text-2xl font-bold text-foreground">{stat?.value}</p>
          </div>
        ))}
      </div>
      <div className="bg-muted/30 rounded-lg p-4">
        <div className="flex items-center justify-between mb-4">
          <h4 className="text-sm font-medium text-foreground">Recent AI Detections</h4>
          <button className="text-sm text-primary hover:text-primary/80 transition-colors">
            View All →
          </button>
        </div>
        <div className="space-y-3">
          {[1, 2, 3]?.map((item) => (
            <div key={item} className="flex items-center justify-between py-2 border-b border-border last:border-0">
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 rounded-full bg-red-500"></div>
                <span className="text-sm text-foreground">Worker without PPE detected</span>
              </div>
              <span className="text-xs text-muted-foreground">{item} min ago</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AIVisionIntegration;